import React, { useEffect, useState } from 'react';
import {
  getPanelManufacturerLogoPath,
  getInverterManufacturerLogoPath,
  getMagazineManufacturerLogoPath,
  getWallboxManufacturerLogoPath,
} from '../utils';

const THUMB = {
  panel: '/thumbnail_panel.png',
  inwerter: '/thumbnail_inverter.png',
  magazyn: '/thumbnail_magazine.png',
  wallbox: '/wallbox-nophoto.png',
};

const LOGO_FN = {
  panel: getPanelManufacturerLogoPath,
  inwerter: getInverterManufacturerLogoPath,
  magazyn: getMagazineManufacturerLogoPath,
  wallbox: getWallboxManufacturerLogoPath,
};

const isUsable = (src) => src != null && String(src).trim() !== '';

// Zdjęcie produktu z fallbackiem do wewnętrznego thumbnaila (gdy brak / błędne).
export const ProductImage = ({ src, alt, productType, className }) => {
  const fallback = THUMB[productType] || THUMB.panel;
  const [imgSrc, setImgSrc] = useState(isUsable(src) ? src : fallback);

  useEffect(() => {
    setImgSrc(isUsable(src) ? src : fallback);
  }, [src, fallback]);

  return (
    <img
      src={imgSrc}
      alt={alt || ''}
      className={className}
      onError={() => { if (imgSrc !== fallback) setImgSrc(fallback); }}
    />
  );
};

// Logo producenta nad zdjęciem — chowa się, gdy pliku brak.
export const ManufacturerLogo = ({ manufacturer, productType, className = '' }) => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => { setHidden(false); }, [manufacturer, productType]);

  const fn = LOGO_FN[productType];
  if (!manufacturer || !fn || hidden) return null;

  return (
    <img
      src={fn(manufacturer)}
      alt={manufacturer}
      onError={() => setHidden(true)}
      className={`max-h-8 w-auto object-contain ${className}`}
    />
  );
};

export default ProductImage;
